import request from "@/utils/request"

//注册
export function apiUser(data) {
  return request({
    url: '/apiUser/queryById',
    method: 'get',
    params: data
  })
}

//编辑信息
export function updateUser(data) {
  return request({
    url: '/apiUser/updateUser',
    method: 'put',
    data
  })
}

//通过用户主键查询作品一览
export function userWorksAll(data) {
  return request({
    url: '/apiUser/getWorks',
    method: 'get',
    params: data
  })
}
//根据h5用户id查询所有证书
export function awardslist(data) {
  return request({
    url: '/awardsWork/selectByUserId',
    method: 'get',
    params: data
  })
}
//查询单个证书
export function getByCertificateResultId(data) {
  return request({
    url: '/awardsWork/getByCertificateResultId',
    method: 'get',
    params: data
  })
}
//查询我的获奖
export function awlist(data) {
  return request({
    url: '/apiUser/listAll',
    method: 'get',
    params: data
  })
}


//文件上传(单个)
export function uploadFile(data) {
  return request({
    url: '/uploadFile',
    method: 'POST',
    data
  })
}


//获取身份证信息
export function getIdentityCard(data) {
  return request({
    url: '/apiUser/getIdentityCard',
    method: 'get',
    params: data
  })
}

//新增身份证信息
export function saveIdentityCard(data) {
  return request({
    url: '/apiUser/saveIdentityCard',
    method: 'post',
    data
  })
}

//  判断用户名是否包含敏感词汇
export function sendRequest(data) {
  return request({
    url: '/h5/sendRequest',
    method: 'get',
    params: data
  })
}




//  通过主键查询用户详情
export function queryByIds(data) {
  return request({
    url: '/apiUser/queryByIds',
    method: 'get',
    params: data
  })
}
